import { createFileRoute } from '@tanstack/react-router';

import { TeamSettings } from '@/features/team/components/team-settings';

export const Route = createFileRoute('/_authenticated/$tenantId/settings/team')(
  {
    component: TeamSettings,
  },
);
